import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import Menu from "./Menu";
import {
  getButtonCollapsedMemory,
  getMenuCollapsedMemory,
  setButtonCollapsedmemory,
  setMenuCollapsedmemory,
} from "../data/memory";
import { useEffect, useState } from "react";
import { useWindowSize } from "./useWindowSize";

export function LoadingSetting() {
  const { width } = useWindowSize();
  const [isMenuCollapsed, setIsMenuCollapsed] = useState(
    getMenuCollapsedMemory()
  ); // Inicializa o estado com o valor da memória
  const [isButtonCollapsed, setIsButtonCollapsed] = useState(
    getButtonCollapsedMemory()
  );

  useEffect(() => {
    if (width < 1000) {
      setIsMenuCollapsed(true);
      setMenuCollapsedmemory(true);
    } else {
      if (!getButtonCollapsedMemory()) {
        setIsMenuCollapsed(false);
        setMenuCollapsedmemory(false);
      }
    }
  }, [width]);

  const handleMenuToggle = () => {
    const newButtonCollapsedState = !isButtonCollapsed;
    const newMenuCollapsedState = !isMenuCollapsed;

    setIsButtonCollapsed(newButtonCollapsedState);
    setButtonCollapsedmemory(newButtonCollapsedState);

    setIsMenuCollapsed(newMenuCollapsedState);
    setMenuCollapsedmemory(newMenuCollapsedState);
  };
  return (
    <main className="flex h-dvh bg-custom-pink">
      <div
        className={`fixed top-0 left-0 h-full ${
          getMenuCollapsedMemory() ? "w-16" : "w-64"
        } bg-custom-pink text-white transition-width duration-300`}
      >
        <button className="p-4 text-white" onClick={handleMenuToggle}>
          {getMenuCollapsedMemory() ? <FaChevronRight /> : <FaChevronLeft />}
        </button>
        <Menu isCollapsed={isMenuCollapsed} />
      </div>
      <section
        className={`flex-1 p-6 bg-white ${
          getMenuCollapsedMemory() ? "ml-16" : "ml-64"
        } transition-margin duration-300 overflow-y-auto`}
      >
        <div className="flex items-center justify-center h-screen bg-white">
          <div className="flex items-center justify-center space-x-2 animate-pulse">
            <div className="w-8 h-8 bg-pink-400 rounded-full"></div>
            <div className="w-8 h-8 bg-pink-500 rounded-full"></div>
            <div className="w-8 h-8 bg-pink-600 rounded-full"></div>
          </div>
        </div>
      </section>
    </main>
  );
}
